import request from '@/config/axios'
import { asCapacityPage, type CapacityPageResult } from '@/api/capacity/page'

export interface RiderCertItem {
  phone?: string
  certStatus?: string
  protocolAgreed?: boolean
  canGoOnline?: boolean
  realName?: string
  idNumber?: string
  idFrontUrl?: string
  idBackUrl?: string
  healthCertUrl?: string
  healthCertExpire?: string
  rejectReason?: string
  success?: boolean
  message?: string
}

export const getPendingRiderCerts = async (params?: {
  pageNo?: number
  pageSize?: number
}): Promise<CapacityPageResult<RiderCertItem>> => {
  const raw = await request.get({ url: '/capacity/platform/rider-cert/pending', params })
  return asCapacityPage<RiderCertItem>(raw, params?.pageNo, params?.pageSize)
}

export const getRiderCert = (phone: string) => {
  return request.get<RiderCertItem>({ url: '/capacity/platform/rider-cert/get', params: { phone } })
}

export const reviewRiderCert = (data: { phone: string; approved: boolean; reason?: string }) => {
  return request.post<RiderCertItem>({ url: '/capacity/platform/rider-cert/review', data })
}

export const unlockAmendRiderCert = (phone: string) => {
  return request.post<RiderCertItem>({ url: '/capacity/platform/rider-cert/unlock-amend', data: { phone } })
}
